import {authHeader} from '../backend'
import {handleResponse} from './handleResponse'

export const ammService = {
  getSummaryAplData,
  getSummaryAplData2,
  getDetailByCourseIdAndHlidx,
  getAnormalHoles,
  getStatisticsData,
  getStatisticsUtilRatioData
}

function getSummaryAplData (searchValue) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }

  let queryString = `?`
  if (searchValue !== undefined && searchValue !== '') {
    queryString = `?searchValue=${encodeURI(searchValue)}&`
  }

  return fetch(`${process.env.BASE_API}/amm/club${queryString}` + Date.now(), requestOptions).then(handleResponse)
}

function getSummaryAplData2 (searchValue) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }

  let queryString = `?`
  if (searchValue !== undefined && searchValue !== '') {
    queryString = `?searchValue=${encodeURI(searchValue)}&`
  }

  return fetch(`${process.env.BASE_API}/amm/apl-all-club${queryString}` + Date.now(), requestOptions).then(handleResponse)
}

function getDetailByCourseIdAndHlidx (aplStatus, activeStatus, batteryStatus, searchValue) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }

  let queryString = `?`
  if (aplStatus !== undefined && aplStatus !== '') {
    queryString += `aplStatus=${encodeURI(aplStatus)}&`
  }
  if (activeStatus !== undefined && activeStatus !== '') {
    queryString += `activeStatus=${encodeURI(activeStatus)}&`
  }
  if (batteryStatus !== undefined && batteryStatus !== '') {
    queryString += `batteryStatus=${encodeURI(batteryStatus)}&`
  }
  if (searchValue !== undefined && searchValue !== '') {
    queryString += `searchValue=${encodeURI(searchValue)}&`
  }

  return fetch(`${process.env.BASE_API}/amm/course-hole${queryString}` + Date.now(), requestOptions).then(handleResponse)
}

function getAnormalHoles () {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }

  return fetch(`${process.env.BASE_API}/amm/club-error?` + Date.now(), requestOptions).then(handleResponse)
}

function getStatisticsData (sDate, eDate) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }

  let queryString = `?`
  if (sDate !== undefined && sDate !== '') {
    queryString += `sDate=${encodeURI(sDate)}&`
  }
  if (eDate !== undefined && eDate !== '') {
    queryString += `eDate=${encodeURI(eDate)}&`
  }

  return fetch(`${process.env.BASE_API}/amm/stats-error${queryString}` + Date.now(), requestOptions).then(handleResponse)
}

function getStatisticsUtilRatioData (sDate, eDate) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }

  let queryString = `?`
  if (sDate !== undefined && sDate !== '') {
    queryString += `sDate=${encodeURI(sDate)}&`
  }
  if (eDate !== undefined && eDate !== '') {
    queryString += `eDate=${encodeURI(eDate)}&`
  }

  return fetch(`${process.env.BASE_API}/amm/apl-all-club-hourly${queryString}` + Date.now(), requestOptions).then(handleResponse)
}



// WEBPACK FOOTER //
// ./src/router/ammRouter.js